// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as React$1 from "@headlessui/react";
var TransitionChild = {};
var Transition = {};
function Transition$1(Props) {
  var showOpt = Props.show;
  var appear = Props.appear;
  var unmount = Props.unmount;
  var as_Opt = Props.as_;
  var enter = Props.enter;
  var enterFrom = Props.enterFrom;
  var enterTo = Props.enterTo;
  var entered = Props.entered;
  var leave = Props.leave;
  var leaveFrom = Props.leaveFrom;
  var leaveTo = Props.leaveTo;
  var className = Props.className;
  var beforeEnter = Props.beforeEnter;
  var afterEnter = Props.afterEnter;
  var beforeLeave = Props.beforeLeave;
  var afterLeave = Props.afterLeave;
  var children = Props.children;
  var style = Props.style;
  var disabledOpt = Props.disabled;
  var dataTestId = Props.dataTestId;
  var show = showOpt !== undefined ? showOpt : false;
  var as_ = as_Opt !== undefined ? as_Opt : "div";
  var disabled = disabledOpt !== undefined ? disabledOpt : false;
  if (disabled) {
    if (!show) {
      return null;
    }
    var tmp = {};
    if (className !== undefined) {
      tmp.className = Caml_option.valFromOption(className);
    }
    if (style !== undefined) {
      tmp.style = Caml_option.valFromOption(style);
    }
    return React.createElement("div", tmp, Belt_Option.getWithDefault(children, null));
  }
  var tmp$1 = {
    show: show,
    as: as_,
    children: children
  };
  if (appear !== undefined) {
    tmp$1.appear = appear;
  }
  if (unmount !== undefined) {
    tmp$1.unmount = unmount;
  }
  if (enter !== undefined) {
    tmp$1.enter = enter;
  }
  if (enterFrom !== undefined) {
    tmp$1.enterFrom = enterFrom;
  }
  if (enterTo !== undefined) {
    tmp$1.enterTo = enterTo;
  }
  if (entered !== undefined) {
    tmp$1.entered = entered;
  }
  if (leave !== undefined) {
    tmp$1.leave = leave;
  }
  if (leaveFrom !== undefined) {
    tmp$1.leaveFrom = leaveFrom;
  }
  if (leaveTo !== undefined) {
    tmp$1.leaveTo = leaveTo;
  }
  if (className !== undefined) {
    tmp$1.className = className;
  }
  if (beforeEnter !== undefined) {
    tmp$1.beforeEnter = Caml_option.valFromOption(beforeEnter);
  }
  if (afterEnter !== undefined) {
    tmp$1.afterEnter = Caml_option.valFromOption(afterEnter);
  }
  if (beforeLeave !== undefined) {
    tmp$1.beforeLeave = Caml_option.valFromOption(beforeLeave);
  }
  if (afterLeave !== undefined) {
    tmp$1.afterLeave = Caml_option.valFromOption(afterLeave);
  }
  if (style !== undefined) {
    tmp$1.style = Caml_option.valFromOption(style);
  }
  if (dataTestId !== undefined) {
    tmp$1["data-testid"] = Caml_option.valFromOption(dataTestId);
  }
  return React.createElement(React$1.Transition, tmp$1);
}
Transition$1.displayName = "Transition.1";
var make = React.memo(Transition$1);
function Transition$Child(Props) {
  var appear = Props.appear;
  var unmount = Props.unmount;
  var as_Opt = Props.as_;
  var enter = Props.enter;
  var enterFrom = Props.enterFrom;
  var enterTo = Props.enterTo;
  var entered = Props.entered;
  var leave = Props.leave;
  var leaveFrom = Props.leaveFrom;
  var leaveTo = Props.leaveTo;
  var className = Props.className;
  var beforeEnter = Props.beforeEnter;
  var afterEnter = Props.afterEnter;
  var beforeLeave = Props.beforeLeave;
  var afterLeave = Props.afterLeave;
  var children = Props.children;
  var style = Props.style;
  var disabledOpt = Props.disabled;
  var as_ = as_Opt !== undefined ? as_Opt : "div";
  var disabled = disabledOpt !== undefined ? disabledOpt : false;
  if (disabled) {
    var tmp = {};
    if (className !== undefined) {
      tmp.className = Caml_option.valFromOption(className);
    }
    if (style !== undefined) {
      tmp.style = Caml_option.valFromOption(style);
    }
    return React.createElement("div", tmp, children);
  }
  var tmp$1 = {
    as: as_,
    children: children
  };
  if (appear !== undefined) {
    tmp$1.appear = appear;
  }
  if (unmount !== undefined) {
    tmp$1.unmount = unmount;
  }
  if (enter !== undefined) {
    tmp$1.enter = enter;
  }
  if (enterFrom !== undefined) {
    tmp$1.enterFrom = enterFrom;
  }
  if (enterTo !== undefined) {
    tmp$1.enterTo = enterTo;
  }
  if (entered !== undefined) {
    tmp$1.entered = entered;
  }
  if (leave !== undefined) {
    tmp$1.leave = leave;
  }
  if (leaveFrom !== undefined) {
    tmp$1.leaveFrom = leaveFrom;
  }
  if (leaveTo !== undefined) {
    tmp$1.leaveTo = leaveTo;
  }
  if (className !== undefined) {
    tmp$1.className = className;
  }
  if (beforeEnter !== undefined) {
    tmp$1.beforeEnter = Caml_option.valFromOption(beforeEnter);
  }
  if (afterEnter !== undefined) {
    tmp$1.afterEnter = Caml_option.valFromOption(afterEnter);
  }
  if (beforeLeave !== undefined) {
    tmp$1.beforeLeave = Caml_option.valFromOption(beforeLeave);
  }
  if (afterLeave !== undefined) {
    tmp$1.afterLeave = Caml_option.valFromOption(afterLeave);
  }
  if (style !== undefined) {
    tmp$1.style = Caml_option.valFromOption(style);
  }
  return React.createElement(React$1.Transition.Child, tmp$1);
}
Transition$Child.displayName = "Transition.Child";
var make$1 = React.memo(Transition$Child);
var Child = {
  make: make$1
};
export { TransitionChild, Transition, make, Child };
/* make Not a pure module */